import { render, staticRenderFns } from "./WebGl.vue?vue&type=template&id=36b10dc0&scoped=true&"
import script from "./WebGl.vue?vue&type=script&lang=js&"
export * from "./WebGl.vue?vue&type=script&lang=js&"
import style0 from "./WebGl.vue?vue&type=style&index=0&id=36b10dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b10dc0",
  null
  
)

export default component.exports